import { connect } from 'react-redux';
import Error404 from './404';

const mapStateToProps = ({ layout }) => ({
    locale: layout.locale,
});

export default connect(mapStateToProps, null)(Error404);
